// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useMemo} from 'react';
import {perr_www_visit} from 'hola_pub_util';
import {Content, I_element} from '../../../../hola/pub/lib/content';
import etask from 'zetask';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {fetch_articles_for_cards} from '../../ui/blog/more_articles';

export const get_data_id = ()=>`/blog/all_articles`;

export const Root = ()=>{
    const {pathname} = use_pathname();
    useEffect(()=>{
        const path_id = pathname.slice(1).replace(/\//g, '_');
        perr_www_visit({id: `oculus_${path_id}_visit`});
    }, []);
    const elements = useMemo<I_element[]>(()=>{
        return [{id: 'blog', type: 'Blog', props: {}}];
    }, []);
    return <div>
      <Content elements={elements}/>
    </div>;
};

Root.meta = {
    no_ssr: false,
    get_data_id,
    set_data_cache: (data_cache, params, data)=>{
        const cache_key = get_data_id();
        data_cache[cache_key] = data;
    },
    data_provider: data_cache=>etask(function*(){
        const cache_key = get_data_id();
        const cached = data_cache[cache_key];
        if (cached)
            return cached;
        const articles = yield fetch_articles_for_cards();
        const result = {
            data: {posts: articles},
            error: '',
            cache_key,
        };
        data_cache[cache_key] = result;
        return result;
    }),
};
